import React, { FC, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { IconContext } from 'react-icons'
import { useDispatch, useSelector } from 'react-redux'
import ICatProveedores from '../../Interfaces/Catalogos/ICatProveedores'
import { RootState } from '../../store/store'
import { BsEraserFill, BsFillPencilFill, BsFillTrashFill, BsSave } from 'react-icons/bs'
import DSCatProveedores from '../../Services/Catalogos/CatProveedores.Services'
import { updateCatProveedores, deleteCatProveedores } from '../../store/features/Catalogos/CatProveedoresSlice'

interface IProps {}

export const CatProveedores: FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const CatProveedores = useSelector((state: RootState) => state.CatProveedores.CatProveedores)
  const [showCatProveedoresDialog, setShowCatProveedoresDialog] = useState(false)
  const [deleteCatProveedoresDialog, setDeleteCatProveedoresDialog] = useState(false)
  const [IDProveedor, setIDProveedor] = useState(0)
  const [Proveedor, setProveedor] = useState('')
  const [Search, setSearch] = useState('')
  const columnsConcepts = [
    {
      name: 'id',
      width: '80px',
      selector: (row: ICatProveedores) => row.id,
      sortable: true,
    },
    {
      name: 'Proveedor',
      width: '450px',
      selector: (row: ICatProveedores) => row.proveedor,
      sortable: true,
    },
    {
      name: 'Editar',
      width: '100px',
      cell: (row: ICatProveedores) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            showInfo(row)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '21px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Elimina',
      width: '100px',
      cell: (row: ICatProveedores) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            confirmDelete(row)
          }}
        >
          <IconContext.Provider value={{ color: 'red', size: '21px' }}>
            <BsFillTrashFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
  ]

  const showInfo = (data: ICatProveedores) => {
    setIDProveedor(data.id)
    setProveedor(data.proveedor)
    setShowCatProveedoresDialog(true)
  }

  const confirmDelete = (data: ICatProveedores) => {
    setIDProveedor(data.id)
    setProveedor(data.proveedor)
    setDeleteCatProveedoresDialog(true)
  }

  const deleteInfo = () => {
    DSCatProveedores.Delete(IDProveedor)
      .then((response) => {
        dispatch(deleteCatProveedores(IDProveedor))
      })
      .catch((e: Error) => {})
    setDeleteCatProveedoresDialog(false)
  }

  const clearForm = () => {
    setIDProveedor(0)
    setProveedor('')
  }

  const saveInfo = () => {
    const data: ICatProveedores = {
      id: IDProveedor,
      proveedor: Proveedor,
      activo: 1,
    }
    DSCatProveedores.Append(data)
      .then((response) => {
        dispatch(updateCatProveedores(response.data))
      })
      .catch((e: Error) => {})
    setShowCatProveedoresDialog(false)
  }

  const filtraReporte = (e: any) => {
    setSearch(e.target.value)
  }
  return (
    <div>
      <Row>
        <Col xs={12}>
          <Card style={{}}>
            <Card.Body>
              <Card.Title style={{ textAlign: 'left' }}>
                <Alert variant='primary'>Proveedores</Alert>
              </Card.Title>
              <Row>
                <Col xs={12}>
                  <Form.Control
                    type='text'
                    size='sm'
                    placeholder='Search...'
                    onChange={(e) => {
                      filtraReporte(e)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <DataTable
                    noHeader
                    defaultSortFieldId={'id'}
                    defaultSortAsc={true}
                    striped={true}
                    dense={true}
                    paginationPerPage={10}
                    pagination
                    highlightOnHover
                    columns={columnsConcepts}
                    data={CatProveedores.filter(function (row: ICatProveedores) {
                      return row.proveedor.includes(Search)
                    })}
                    pointerOnHover
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={showCatProveedoresDialog}
        onHide={() => {
          setShowCatProveedoresDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Proveedores</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={4}>No proveedor</Col>
            <Col xs={2}>
              <Form.Control type='text' id='IDCliente' value={IDProveedor} disabled size='sm' />
            </Col>
            <Col xs={1} style={{ textAlign: 'left' }}>
              <Button
                size='sm'
                variant='white'
                onClick={() => {
                  clearForm()
                }}
              >
                <IconContext.Provider value={{ color: 'orange', size: '25px' }}>
                  <BsEraserFill />
                </IconContext.Provider>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={2}>Proveedor</Col>
            <Col xs={10}>
              <Form.Control
                type='text'
                id='Proveedor'
                value={Proveedor}
                size='sm'
                onChange={(e) => {
                  setProveedor(e.target.value)
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='primary'
                onClick={() => {
                  saveInfo()
                }}
              >
                Guarda
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <Modal
        show={deleteCatProveedoresDialog}
        onHide={() => {
          setDeleteCatProveedoresDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Proveedores</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <br />
          <Row>
            <Col xs={12}>
              <Alert variant='warning'>
                ¿Esta seguro de que desea eliminar el proveedor: <br />
                <span style={{ fontWeight: 'bold', fontSize: '20px' }}>{Proveedor}</span>?
              </Alert>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='danger'
                onClick={() => {
                  deleteInfo()
                }}
              >
                Elimina
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
